'use client';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useSession } from 'next-auth/react';
import { useT } from '@/lib/i18n';
import { LanguagePicker } from './LanguagePicker';

export function AppTopBar() {
  const t = useT();
  const pathname = usePathname();
  const { data: session } = useSession();

  const titles: Record<string, string> = {
    '/': t('app.title'),
    '/leaderboard': t('nav.leaderboard'),
    '/profile': t('nav.profile'),
    '/login': t('auth.login'),
    '/register': t('auth.register'),
  };
  const title = titles[pathname] ?? t('app.title');

  return (
    <header
      className="shrink-0 bg-sky-50/95 backdrop-blur border-b border-sky-200 z-20"
    >
      <div className="h-8 flex items-center justify-between px-4">
        <span className="font-bold tracking-tight text-slate-900">{title}</span>
        <div className="flex items-center gap-1">
          <LanguagePicker />
          {session ? (
          <Link href="/profile" aria-label="Profile">
            {session.user?.image ? (
              /* eslint-disable-next-line @next/next/no-img-element */
              <img src={session.user.image} alt=""
                className="w-8 h-8 rounded-full object-cover border-2 border-violet-300" />
            ) : (
              <div className="w-8 h-8 rounded-full bg-violet-600 flex items-center justify-center text-xs font-bold text-white">
                {(session.user?.name ?? session.user?.email ?? '?')[0].toUpperCase()}
              </div>
            )}
          </Link>
        ) : (
          <Link href="/login"
            className="text-sm font-semibold text-violet-600 px-3 py-1 rounded-lg bg-violet-50 active:bg-violet-100">
            {t('auth.login')}
          </Link>
        )}
        </div>
      </div>
    </header>
  );
}
